import { Action, combineReducers } from "redux";
import * as store from "../../../framework/customStore";
import { TDefaultListFilter } from "../../common/defaultListFilter";
import { IRiskPage } from "../../risk/riskPage";
import { TDefaultReportFilter } from "source/models/common/defaultReportFilter";

// State
export interface IRiskPageState {
    dataId: number;
    riskPage: IRiskPage;
}

export interface IRiskListState {
    defaultFilter: TDefaultListFilter;
}

export interface IRiskReportState {
    defaultFilter: TDefaultReportFilter;
}

export interface IRiskState {
    page: IRiskPageState;
    list: IRiskListState;
    report: IRiskReportState;
}

// Action type constants
const RISK_SUCCESS = "RISK_SUCCESS";
const RISK_FAILURE = "RISK_FAILURE";

const RISK_SUCCESS_LIST_SET_DEFAULT_FILTER = "RISK_SUCCESS_LIST_SET_DEFAULT_FILTER";

const RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER = "RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER";

type T_RISK_SUCCESS = typeof RISK_SUCCESS;
type T_RISK_FAILURE = typeof RISK_FAILURE;

type T_RISK_SUCCESS_LIST_SET_DEFAULT_FILTER = typeof RISK_SUCCESS_LIST_SET_DEFAULT_FILTER;

type T_RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER = typeof RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER;

// Action types
interface IRiskSuccess extends Action {
    type: T_RISK_SUCCESS;
    riskPage: IRiskPage;
}

interface IRiskFailure extends Action {
    type: T_RISK_FAILURE;
}

interface IRiskListSetDefaultFilter extends Action {
    type: T_RISK_SUCCESS_LIST_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultListFilter;
}

interface IRiskReportSetDefaultFilter extends Action {
    type: T_RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultReportFilter;
}

export type RiskAction =
    | IRiskSuccess
    | IRiskFailure
    | IRiskListSetDefaultFilter
    | IRiskReportSetDefaultFilter;

//Actions
export const riskSuccess = (riskPage: IRiskPage): IRiskSuccess => ({
    type: RISK_SUCCESS,
    riskPage
});

export const riskFailure = (): IRiskFailure => ({
    type: RISK_FAILURE
});

export const riskListSetDefaultFilter = (defaultFilter: TDefaultListFilter): IRiskListSetDefaultFilter => ({
    type: RISK_SUCCESS_LIST_SET_DEFAULT_FILTER,
    defaultFilter
});

export const riskReportSetDefaultFilter = (defaultFilter: TDefaultReportFilter): IRiskReportSetDefaultFilter => ({
    type: RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER,
    defaultFilter
});

//Reducers
export const riskInitialState: IRiskState = {
    page: {
        dataId: 0,
        riskPage: null
    },
    list: {
        defaultFilter: null
    },
    report: {
        defaultFilter: null
    }
};

const page = (state: IRiskPageState = null, action: RiskAction) => {
    switch (action.type) {
    case RISK_SUCCESS: {
        const success = action as IRiskSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            riskPage: success.riskPage
        };
    }
    case RISK_FAILURE:
        return { ...state };
    }
    return state;
};

const list = (state: IRiskListState = null, action: RiskAction) => {
    switch (action.type) {
    case RISK_SUCCESS_LIST_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as IRiskListSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

const report = (state: IRiskReportState = null, action: RiskAction) => {
    switch (action.type) {
    case RISK_SUCCESS_REPORT_SET_DEFAULT_FILTER: {
        const reportDefaultFilter = action as IRiskReportSetDefaultFilter;
        return {
            ...state,
            defaultFilter: reportDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

//Root reducer
export const riskReducer = combineReducers({
    page,
    list,
    report
});

//Utils
export const setRiskListDefaultFilter = (defaultFilter: TDefaultListFilter) => {
    store.customStore.dispatch(riskListSetDefaultFilter(defaultFilter));
};

export const setRiskReportDefaultFilter = (defaultFilter: TDefaultReportFilter) => {
    store.customStore.dispatch(riskReportSetDefaultFilter(defaultFilter));
};
